<!-- Строка read-only данных внутри секции титула ЭДО. -->
<template>
  <div class="preview-item">
    <span class="preview-label">{{ row.label }}</span>
    <span class="preview-value">{{ row.value }}</span>
  </div>
</template>

<script>
export default {
  name: "EdoDocumentPreviewRow",

  props: {
    row: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.preview-item {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr);
  gap: 12px;
  min-width: 0;
}

.preview-label {
  color: #6b7280;
  font-size: 13px;
  line-height: 1.4;
}

.preview-value {
  min-width: 0;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

@media (max-width: 640px) {
  .preview-item {
    grid-template-columns: 1fr;
    gap: 2px;
  }

  .preview-label {
    font-size: 11px;
    line-height: 1.25;
  }

  .preview-value {
    font-size: 12px;
    line-height: 1.3;
  }
}
</style>
